var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "myexam-card-container" }, [
    _c("div", { staticClass: "simple-container" }, [
      _c(
        "div",
        { staticClass: "exam-title" },
        [
          _c("div", { staticClass: "title-icon" }, [
            _vm.itemType == "exam"
              ? _c("img", {
                  staticClass: "icon",
                  attrs: { src: "/static/img/icon_ks.png", alt: "" },
                })
              : _c("img", {
                  staticClass: "icon",
                  attrs: { src: "/static/img/icon_lx.png", alt: "" },
                }),
          ]),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                content: _vm.examtitle,
                effect: "light",
                placement: "top-start",
              },
            },
            [
              _c("div", { staticClass: "title-text" }, [
                _vm._v(" " + _vm._s(_vm.examtitle) + " "),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "exam-time" }, [
        _c("div", [
          _vm.itemType == "exam"
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.examInfo["exam_manage_goinglistdata.exam_date_time"]
                  ) + " "
                ),
              ])
            : _vm._e(),
          _vm.itemType == "training"
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.examInfo["exam_training_doingdatalist.training_time"]
                  ) + " "
                ),
              ])
            : _vm._e(),
          _vm.examInfo["exam_manage_goinglistdata.exam_time"]
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.examInfo["exam_manage_goinglistdata.exam_time"]) +
                    "分钟"
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.itemType == "exam"
        ? _c("div", { staticClass: "exam-num" }, [
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_manage_goinglistdata.total_score"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("考试总分")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_manage_goinglistdata.pass_score"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("及格分数")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.examInfo["exam_manage_goinglistdata.exam_num"]) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("考试次数")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.examInfo["exam_manage_goinglistdata.last_num"]) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("已考次数")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_manage_goinglistdata.tested_num"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("剩余次数")]),
            ]),
          ])
        : _vm._e(),
      _vm.itemType == "training"
        ? _c("div", { staticClass: "exam-num" }, [
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.examInfo["exam_training_doingdatalist.num"]) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("练习总题")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_training_doingdatalist.checkbox_num"] -
                        0 +
                        (_vm.examInfo["exam_training_doingdatalist.radio_num"] -
                          0)
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("选择题")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_training_doingdatalist.input_num"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("填空题")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_training_doingdatalist.judge_num"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("判断题")]),
            ]),
            _c("div", { staticClass: "num-item" }, [
              _c("div", { staticClass: "num-value" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.examInfo["exam_training_doingdatalist.last_num"]
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "num-title" }, [_vm._v("练习次数")]),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "exam-divided-line" }),
      _vm.itemType == "exam"
        ? _c(
            "div",
            { staticClass: "exam-btnnav" },
            [
              _c(
                "DsfButton",
                {
                  attrs: { type: "plain" },
                  on: {
                    click: function ($event) {
                      return _vm.getRules()
                    },
                  },
                },
                [_vm._v(" 考生须知 ")]
              ),
              _vm.examInfo.isExist == "1"
                ? _c(
                    "DsfButton",
                    {
                      attrs: { type: "plain" },
                      on: {
                        click: function ($event) {
                          return _vm.checkExam()
                        },
                      },
                    },
                    [_vm._v("查看结果")]
                  )
                : _vm._e(),
              _vm.examInfo["viewStatus"] == 2 &&
              _vm.examInfo["exam_manage_goinglistdata.exam_num"] !== 0
                ? _c(
                    "DsfButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.continueExam()
                        },
                      },
                    },
                    [_vm._v("继续考试")]
                  )
                : _vm._e(),
              (_vm.examInfo["viewStatus"] == 1 &&
                _vm.examInfo["exam_manage_goinglistdata.exam_num"] !== 0) ||
              (_vm.examInfo["viewStatus"] == 4 && _vm.queryString.type !== "1")
                ? _c(
                    "DsfButton",
                    {
                      attrs: { disabled: _vm.examInfo["viewStatus"] == 4 },
                      on: {
                        click: function ($event) {
                          return _vm.startExam()
                        },
                      },
                    },
                    [_vm._v("开始考试")]
                  )
                : _vm._e(),
              _vm.examInfo["viewStatus"] == 3
                ? _c(
                    "DsfButton",
                    {
                      attrs: { disabled: true },
                      on: {
                        click: function ($event) {
                          return _vm.openExamTips()
                        },
                      },
                    },
                    [_vm._v("未开始")]
                  )
                : _vm._e(),
              _vm.examInfo["exam_manage_goinglistdata.exam_num"] <= 0
                ? _c(
                    "DsfButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openExamTips()
                        },
                      },
                    },
                    [_vm._v("提示")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.itemType == "training"
        ? _c(
            "div",
            { staticClass: "exam-btnnav" },
            [
              _vm.examInfo["exam_training_doingdatalist.last_num"] > 0 &&
              _vm.examInfo["exam_training_doingdatalist.num"] > 0
                ? _c(
                    "DsfButton",
                    {
                      attrs: {
                        type: _vm.queryString.type == "0" ? "plain" : "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.checkTraining()
                        },
                      },
                    },
                    [_vm._v("查看练习")]
                  )
                : _vm._e(),
              _vm.examInfo["exam_training_doingdatalist.type"] == 2 &&
              _vm.examInfo["exam_training_doingdatalist.num"] > 0 &&
              _vm.canToTraining === true
                ? _c(
                    "DsfButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.continueTraining()
                        },
                      },
                    },
                    [_vm._v("继续练习")]
                  )
                : _vm._e(),
              _vm.examInfo["exam_training_doingdatalist.type"] == 1 &&
              _vm.examInfo["exam_training_doingdatalist.num"] > 0 &&
              _vm.canToTraining === true
                ? _c(
                    "DsfButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.startTraining()
                        },
                      },
                    },
                    [_vm._v("开始练习")]
                  )
                : _vm._e(),
              _vm.showTips === true
                ? _c(
                    "DsfButton",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openTrainingTips()
                        },
                      },
                    },
                    [_vm._v("提示")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }